<template>
  <SignInChargeComponent
    v-bind="$attrs"
    :time="time"
    :chartLineData="chartLineData"
    :checkInAll="checkInAll"
    :chartMapData="chartMapData"
    :charLineSetting="charLineSetting"
    :signBtn="signBtn"
    :getVipAreaData="_getVipAreaData"
    :signPagination="signPagination"
  >
    <template #chart-line__head>
      <el-button
        size="120 "
        round
        class="fff-color"
        v-for="(item, index) in chartLine"
        :key="index"
        :class="activeIndex === index ? 'active' : ''"
        @click="changeSignChartData({ search_mode: item.mode }, index)"
      >
        {{ item.title }}
      </el-button>
    </template>
    <template #check-in__show>
      <div class="all-num">
        <span>
          <span class="num">
            {{ checkInAll }}
          </span>
          签到总人次
        </span>
      </div>
      <div class="icon">
        <i v-for="item in [1, 2, 3, 4, 5, 6]" class="iconfont icon-ren"></i>
      </div>
    </template>
    <template #tips>
      <span class="tips">
        会员所在区域签到数据
        <br />
        （单位：人次）
      </span>
    </template>
    <template #filterInput>
      <SearchComponent
        :condition="condition"
        @updateData="_updateData"
        ref="search"
      >
        <template #default="{searchData,condition,pickerOptions}">
          <div class="input-box">
            <span class="name">会员名称：</span>
            <div class="input">
              <el-input
                v-model="condition.name"
                placeholder="请输入"
                clearable
              />
            </div>
          </div>
          <div class="input-box">
            <span class="name">会员手机号：</span>
            <div class="input">
              <el-input
                v-model="condition.phone"
                placeholder="请输入"
                clearable
              />
            </div>
          </div>
          <div class="input-box">
            <span class="name">会员性别：</span>
            <div class="input">
              <el-select
                v-model="condition.gender"
                placeholder="请选择"
                clearable
              >
                <el-option label="男" value="1" />
                <el-option label="女" value="2" />
                <el-option label="保密" value="3" />
              </el-select>
            </div>
          </div>
          <div class="input-box datepick">
            <span class="name">签到时间：</span>
            <div class="input">
              <el-date-picker
                v-model="condition.checkInTime"
                type="daterange"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                clearable
              />
            </div>
          </div>
          <div class="input-box">
            <span class="name">签到区域：</span>
            <div class="input">
              <el-cascader
                v-model="condition.checkInArea"
                :options="area"
                :props="{ checkStrictly: true }"
                clearable
              />
            </div>
          </div>
          <div class="input-box">
            <span class="name">会员等级：</span>
            <div class="input">
              <el-select
                v-model="condition.level"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in filterDownData('levelList')"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
          <el-button
            @click="searchData"
            size="60"
            class="iconfont icon-sousuo"
            round
          />
        </template>
      </SearchComponent>
    </template>
    <template #table>
      <TableComponent
        @updateData="_updateData"
        :tableData="tableData"
        :pagination="pagination"
      >
        <template #default>
          <el-table-column fixed type="selection" align="center" width="135" />
          <el-table-column
            prop="id"
            label="序号"
            align="center"
            min-width="60"
          />
          <el-table-column align="center" min-width="180" label="头像">
            <template slot-scope="scope">
              <div class="avatar">
                <img :src="scope.row.avatar" alt="" />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            align="center"
            min-width="180"
            label="名称"
          />
          <el-table-column
            prop="name1"
            label="姓名"
            min-width="180"
            align="center"
          />
          <el-table-column label="性别" min-width="180" align="center">
            <template slot-scope="scope">
              {{ scope.row.gender | formatSex }}
            </template>
          </el-table-column>
          <el-table-column
            prop="phone"
            label="手机号"
            align="center"
            min-width="180"
          />
          <el-table-column
            prop="level"
            label="等级"
            min-width="180"
            align="center"
          />
          <el-table-column
            prop="registerTime"
            label="注册时间"
            align="center"
            min-width="180"
          />
          <el-table-column
            prop="checkInNumber"
            label="签到次数"
            min-width="180"
            align="center"
          />
          <el-table-column
            prop="lastCheckInTime"
            label="最后一次签到时间"
            align="center"
            min-width="180"
          />
          <el-table-column
            fixed="right"
            prop="checkInIntegral"
            label="签到积分"
            align="center"
            min-width="180"
          />
        </template>
      </TableComponent>
    </template>
  </SignInChargeComponent>
</template>

<script>
import SignInChargeComponent from '../Components/CheckInChargeComponent/'
import SearchComponent from '../Components/SearchComponent/'
import TableComponent from '../Components/TableComponent/'
import updateData from 'mixins/updateData'
import filterDownData from 'mixins/filterDownData'

export default {
  name: 'vipSignIn',
  mixins: [updateData, filterDownData],
  components: {
    SearchComponent,
    TableComponent,
    SignInChargeComponent
  },
  data() {
    this.keyMap = {
      sign_list: {
        name: 'tableData',
        sign_number: 'checkInNumber',
        member_avatar: 'avatar',
        member_name: 'name',
        member_id: 'id',
        memebr_truename: 'name1',
        member_sex: 'gender',
        member_mobile: 'phone',
        member_time: 'registerTime',
        level_name: 'level',
        sign_time: 'lastCheckInTime',
        point_number: 'checkInIntegral'
      },
      area_list: {
        name: 'areaList',
        area_deep: 'deep',
        area_name: 'label',
        area_parent_id: 'parentId',
        area_id: 'value',
        city_list: 'children',
        city_two: 'children',
        city_three: 'children',
        city_four: 'children'
      },
      sign_data: {
        name: 'signData',
        date_time: '时间',
        sign_number: '签到人数',
        subName: 'rows',
        adds: [
          {
            name: 'columns',
            value: ['时间', '签到人数']
          }
        ]
      },
      area_data: {
        name: 'areaData',
        sign_number: '签到人数',
        area_name: 'area',
        subName: 'rows',
        adds: [
          {
            name: 'columns',
            value: ['area', '签到人数']
          }
        ]
      }
    }

    this.chartLine = [
      { title: '实时签到数据', mode: 'real_time' },
      { title: '7天签到数据', mode: 'seven_day' },
      { title: '30天签到数据', mode: 'thirty_day' }
    ]

    this.charLineSetting = {
      yAxisName: ['单位 / 人 ']
    }

    this.signBtn = [
      {
        title: '全部省份',
        mode: 'sign',
        type: 'province'
      },
      {
        title: '全部城市',
        mode: 'sign',
        type: 'city'
      }
    ]

    return {
      time: '',
      activeIndex: 1,
      chartLineData: {},
      chartMapData: {},
      signPagination: {
        currentPage: 1,
        pageTotal: ''
      },
      area: [],
      checkInAll: '',
      condition: {
        name: '',
        phone: '',
        checkInTime: '',
        gender: '',
        level: '',
        checkInArea: ''
      },
      tableData: [],
      pagination: {
        currentPage: 1,
        recordTotal: -1,
        pageTotal: -1
      }
    }
  },
  created() {
    this._getSignList({
      curpage: 1
    })
    this._getProvinces()
    this.changeSignChartData({
      search_mode: 'seven_day',
      entry_mode: 'member_sign'
    })
    this._getVipAreaData({
      search_mode: 'sign',
      curpage: 1,
      see_type: 'province'
    })
  },
  methods: {
    /**
     * 获取签到列表
     * @private
     */
    _getSignList(params) {
      this.api.getSignList(params).then(res => {
        this.utils.setCommonCode(res, this)
        this.checkInAll = this.pagination.recordTotal
      })
    },
    /**
     * 获取签到区域
     * @private
     */
    _getProvinces() {
      this.api.getVipProvinces().then(res => {
        this.utils._modifyObjKey(res.province_list, this.keyMap)
        this.area = res.province_list.areaList
      })
    },
    /**
     * 切换签到数据
     * @param params
     * @param index
     */
    changeSignChartData(params, index) {
      if (index >= 0) {
        this.activeIndex = index
      }
      params.entry_mode = 'member_sign'
      this.api.changeData(params).then(res => {
        if (res.sign_data.length > 0) {
          if (params.search_mode === 'real_time') {
            this.time = new Date().toLocaleDateString().replace(/\//g, '-')
          } else {
            this.time = `${res.sign_data[0].date_time}~${
              res.sign_data.slice(-1)[0].date_time
            }`
          }
        }
        this.utils._modifyObjKey(res, this.keyMap)
        this.chartLineData = res.signData
      })
    },
    /**
     * 获取会员签到分布数据
     * @param params
     */
    _getVipAreaData(params) {
      return this.api.getVipAreaData(params).then(res => {
        this.utils._modifyObjKey(res, this.keyMap)
        this.chartMapData = res.areaData
        this.signPagination.pageTotal = +res.page_count
      })
    }
  }
}
</script>
